import StatusUtil from '../../../util/StatusUtil';
import NumberCondition from '../../abstract-search/filters/conditions/Number';
import FieldOptions from '../../abstract-search/filters/conditions/FieldOptions';

import Timestamp from '../../../elements/Timestamp';
import Money from '../../../elements/Money';
import Number from '../../../elements/Number';
import JsonListDisplay from '../../abstract-search/projections/column-type-display/JsonListDisplay';
import OptionDisplay from '../../abstract-search/projections/column-type-display/OptionDisplay';

import FieldUtil from '../../abstract-search/util/FieldUtil';
import IdDisplay from "../../abstract-search/projections/column-type-display/IdDisplay";

const mapStatusesToNiceOptions = (options) => {
    return options.map(o => {
        return {
            value : o.id,
            label : o.name,
        };
    });
};

const CHANNEL_INVOICE_GROUP = 'Invoice';

let fields = [
    FieldUtil.createField(
        'Order Status',
        'order.order_status_id',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'orderStatusId',
            options : mapStatusesToNiceOptions(Object.values(StatusUtil.ORDER)),
            filterComponent : FieldOptions,
            overrideComparators : FieldUtil.baseComparators(NumberCondition),
            searchable : false,
            displayComponent : OptionDisplay,
        }
    ),
    FieldUtil.createField(
        'Payment Status',
        'order.payment_status_id',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentStatusId',
            options : mapStatusesToNiceOptions(Object.values(StatusUtil.PAYMENT)),
            filterComponent : FieldOptions,
            overrideComparators : FieldUtil.baseComparators(NumberCondition),
            searchable : false,
            displayComponent : OptionDisplay,
        }
    ),

    FieldUtil.createField(
        'Allocation Status',
        'order.allocated_status_id',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'allocatedStatusId',
            options : mapStatusesToNiceOptions(Object.values(StatusUtil.ALLOCATION)),
            filterComponent : FieldOptions,
            overrideComparators : FieldUtil.baseComparators(NumberCondition),
            searchable : false,
            displayComponent : OptionDisplay,
        }
    ),
    FieldUtil.createField(
        'Acknowledged Status',
        'order.acknowledged_status_id',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'acknowledgedStatusId',
            options : mapStatusesToNiceOptions(Object.values(StatusUtil.ACKNOWLEDGED)),
            filterComponent : FieldOptions,
            overrideComparators : FieldUtil.baseComparators(NumberCondition),
            searchable : false,
            displayComponent : OptionDisplay,
        }
    ),
    FieldUtil.createField(
        'Shipment Status',
        'order.shipped_status_id',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'shippedStatusId',
            options : mapStatusesToNiceOptions(Object.values(StatusUtil.SHIPPED)),
            filterComponent : FieldOptions,
            overrideComparators : FieldUtil.baseComparators(NumberCondition),
            searchable : false,
            displayComponent : OptionDisplay,
        }
    ),
    FieldUtil.createField(
        'Ordered On',
        'order.ordered_at',
        'Order',
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'orderedAt',
            displayComponent : Timestamp,
        },
    ),
    FieldUtil.createField(
        'Imported On',
        'order.inserted_at',
        'Order',
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'insertedAt',
            displayComponent : Timestamp,
        },
    ),
    FieldUtil.createField(
        'Last Updated On',
        'order.updated_at',
        'Order',
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'updatedAt',
            displayComponent : Timestamp,
        },
    ),
    FieldUtil.createField(
        'Canceled On',
        'order.canceled_at',
        'Order',
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'canceledAt',
            displayComponent : Timestamp,
        },
    ),
    FieldUtil.createField(
        'Order #',
        'order.id',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'id',
            displayComponent : IdDisplay,
        }
    ),
    FieldUtil.createField(
        'Reference #',
        'order.reference_number',
        'Order',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'referenceNumber',
        }
    ),
    FieldUtil.createField(
        'Order Total',
        'order.order_total',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'orderTotal',
            displayComponent : Money,
        }
    ),
    FieldUtil.createField(
        'Total Line Items',
        'order.total_order_items',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'totalOrderItems',
            displayComponent : Number,
        }
    ),
    FieldUtil.createField(
        'Total Quantity',
        'order.total_quantity',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'totalQuantity',
            displayComponent : Number,
        }
    ),
    FieldUtil.createField(
        'Total Weight',
        'order.total_weight',
        'Order',
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'totalWeight',
            displayComponent : Number,
        }
    ),

    //Line Items
    FieldUtil.createField(
        'SKU',
        'order_item.sku',
        'Order Line Item',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'orderItemSkus',
            displayComponent : JsonListDisplay,
            searchable : true,
            sortingDisabled : true,
        }
    ),
    FieldUtil.createField(
        'Title',
        'order_item.title',
        'Order Line Item',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'orderItemTitles',
            displayComponent : JsonListDisplay,
            searchable : true,
            sortingDisabled : true,
        }
    ),

    //Payment
    FieldUtil.createField(
        'Refund Status',
        'order.payment_refund_status_id',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentRefundStatusId',
            options : mapStatusesToNiceOptions(Object.values(StatusUtil.PAYMENT_REFUND)),
            filterComponent : FieldOptions,
            overrideComparators : FieldUtil.baseComparators(NumberCondition),
            searchable : false,
            displayComponent : OptionDisplay,
        }
    ),
    FieldUtil.createField(
        'Credit Status',
        'order.payment_credit_status_id',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentCreditStatusId',
            options : mapStatusesToNiceOptions(Object.values(StatusUtil.PAYMENT_REFUND)),
            filterComponent : FieldOptions,
            overrideComparators : FieldUtil.baseComparators(NumberCondition),
            searchable : false,
            displayComponent : OptionDisplay,
        }
    ),
    FieldUtil.createField(
        'Channel Invoice #',
        'payment.invoice_number',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'paymentPaymentNumber',
        }
    ),
    FieldUtil.createField(
        'Generated On',
        'payment.invoiced_at',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'paymentInvoicedAt',
            displayComponent : Timestamp,
        }
    ),
    FieldUtil.createField(
        'Paid On',
        'payment.paid_at',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'paymentPaidAt',
            displayComponent : Timestamp,
        }
    ),
    FieldUtil.createField(
        'Shipping Cost',
        'payment.shipping_cost',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentShippingCost',
            displayComponent : Money,
        }
    ),
    FieldUtil.createField(
        'Dropship Fee',
        'payment.dropship_fee',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentDropshipFee',
            displayComponent : Money,
        }
    ),
    FieldUtil.createField(
        'Refunded Amount',
        'payment.refunded_amount',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentRefundedAmount',
            displayComponent : Money,
        }
    ),
    FieldUtil.createField(
        'Refunded Count',
        'payment.refunded_number_of_times',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentRefundedNumberOfTimes',
            displayComponent : Number,
        }
    ),
    FieldUtil.createField(
        'Refunded On',
        'payment.refunded_last_at',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'paymentRefundedLastAt',
            displayComponent : Timestamp,
        }
    ),
    FieldUtil.createField(
        'Credited Amount',
        'payment.credited_amount',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentCreditedAmount',
            displayComponent : Money,
        }
    ),
    FieldUtil.createField(
        'Credited Count',
        'payment.credited_number_of_times',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentCreditedNumberOfTimes',
            displayComponent : Number,
        }
    ),
    FieldUtil.createField(
        'Credited On',
        'payment.credited_last_at',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'paymentCreditedLastAt',
            displayComponent : Timestamp,
        }
    ),

    FieldUtil.createField(
        'Credit Applied',
        'payment.credit_applied_towards_total',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.number,
        {
            contextKey : 'paymentCreditAppliedTowardsTotal',
            displayComponent : Money,
        }
    ),
    FieldUtil.createField(
        'Deferred',
        'payment.payment_deferred',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.boolean,
        {
        }
    ),
    FieldUtil.createField(
        'Deferred On',
        'payment.payment_deferred_at',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.timestamp,
        {
            displayComponent : Timestamp,
        }
    ),
    FieldUtil.createField(
        'Deferred Until',
        'payment.payment_deferred_until',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.timestamp,
        {
            displayComponent : Timestamp,
        }
    ),
    FieldUtil.createField(
        'Receipt Sent',
        'payment.receipt_sent',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.boolean,
        {
            contextKey : 'paymentReceiptSent'
        }
    ),
    FieldUtil.createField(
        'Receipt Sent On',
        'payment.receipt_sent_at',
        CHANNEL_INVOICE_GROUP,
        FieldUtil.DATA_TYPES.timestamp,
        {
            contextKey : 'paymentRecentSentAt',
            displayComponent : Timestamp,
        }
    ),

    //Shipping Address Fields
    FieldUtil.createField(
        'Ship To Name',
        'shipping_address.name',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressName',
        }
    ),
    FieldUtil.createField(
        'Shipping Line 1',
        'shipping_address.line_1',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressLine1',
        }
    ),
    FieldUtil.createField(
        'Shipping Line 2',
        'shipping_address.line_2',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressLine2',
        }
    ),
    FieldUtil.createField(
        'Shipping City',
        'shipping_address.city',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressCity',
        }
    ),
    FieldUtil.createField(
        'Shipping State',
        'shipping_address.state',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressState',
        }
    ),
    FieldUtil.createField(
        'Shipping State Code',
        'shipping_address.state_code',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressStateCode',
        }
    ),
    FieldUtil.createField(
        'Shipping Country',
        'shipping_address.country',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressCountry',
        }
    ),
    FieldUtil.createField(
        'Shipping Country Code',
        'shipping_address.country_code',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressCountryCode',
        }
    ),
    FieldUtil.createField(
        'Shipping Postal',
        'shipping_address.postal',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressPostal',
        }
    ),
    FieldUtil.createField(
        'Shipping Email',
        'shipping_address.email',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressEmail',
        }
    ),
    FieldUtil.createField(
        'Shipping Phone',
        'shipping_address.phone',
        'Shipping Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'shippingAddressPhone',
        }
    ),

    //Billing Address Fields
    FieldUtil.createField(
        'Ship To Name',
        'billing_address.name',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressNam',
        }
    ),
    FieldUtil.createField(
        'Billing Line 1',
        'billing_address.line_1',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressLine1',
        }
    ),
    FieldUtil.createField(
        'Billing Line 2',
        'billing_address.line_2',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressLine2',
        }
    ),
    FieldUtil.createField(
        'Billing City',
        'billing_address.city',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressCity',
        }
    ),
    FieldUtil.createField(
        'Billing State',
        'billing_address.state',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressState',
        }
    ),
    FieldUtil.createField(
        'Billing State Code',
        'billing_address.state_code',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressStateCode',
        }
    ),
    FieldUtil.createField(
        'Billing Country',
        'billing_address.country',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressCountry',
        }
    ),
    FieldUtil.createField(
        'Billing Country Code',
        'billing_address.country_code',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressCountryCode',
        }
    ),
    FieldUtil.createField(
        'Billing Postal',
        'billing_address.postal',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressPostal',
        }
    ),
    FieldUtil.createField(
        'Billing Email',
        'billing_address.email',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressEmail',
        }
    ),
    FieldUtil.createField(
        'Billing Phone',
        'billing_address.phone',
        'Billing Address',
        FieldUtil.DATA_TYPES.string,
        {
            contextKey : 'billingAddressPhone',
        }
    ),

];

const groupNamesInOrder = ['Order', 'Order Line Item', CHANNEL_INVOICE_GROUP, 'Dealer', 'Source', 'Channel', 'Shipping Address', 'Billing Address'];

export default FieldUtil.buildAvailableFields(fields, groupNamesInOrder);
